import { AdminSpecialArticles } from './AdminSpecialArticles'

export default AdminSpecialArticles